import './StrapCandidateSelector.less';
import React, {useState, useEffect} from 'react';
import ImageView from '../image-view/ImageView';


export default function StrapCandidateSelector(
    {
        strapCandidates,
        images,
        defaultSelectedStrapCandidateId = null,
        onSelectedStrapCandidateIdChange = (selectedId) => {},
    }
) {

    const [selectedStrapCandidateId, setSelectedStrapCandidateId] = useState(defaultSelectedStrapCandidateId);

    useEffect(() => {
        if (selectedStrapCandidateId !== defaultSelectedStrapCandidateId) {
            onSelectedStrapCandidateIdChange(selectedStrapCandidateId);
        }
    }, [selectedStrapCandidateId]);

    useEffect(() => {
        if (selectedStrapCandidateId !== defaultSelectedStrapCandidateId) {
            setSelectedStrapCandidateId(defaultSelectedStrapCandidateId);
        }
    }, [defaultSelectedStrapCandidateId]);

    return <div className="strap-candidate-selector">
        <ul>
            {
                strapCandidates
                    .map(item => {

                        const image = images.find(img => img.id === item.lower_image_id);

                        return <li
                            key={item.id}
                            onClick={() => setSelectedStrapCandidateId(item.id)}
                            className={item.id === selectedStrapCandidateId ? 'selected' : ''}
                        >
                            {
                                image &&
                                <ImageView
                                    image={image}
                                    ratio={1}
                                />
                            }
                        </li>;
                    })
            }
        </ul>
    </div>;
}
